import { render, staticRenderFns } from "./UserSendEmail.vue?vue&type=template&id=04b084ad&scoped=true&"
import script from "./UserSendEmail.vue?vue&type=script&lang=ts&"
export * from "./UserSendEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b084ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions,VCardTitle})
